<button
  [type]="type"
  [disabled]="disabled"
  class="app-button"
  [ngClass]="classButton"
  [attr.aria-label]="ariaLabel"
  [attr.aria-describedby]="ariaDescribedby"
>
  <app-progress-spinner
    class="button-spinner"
    *ngIf="isLoading"
    [diameter]="20"
  ></app-progress-spinner>
  <ng-content></ng-content>
</button>
